import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CSSTransition } from 'react-transition-group';
import * as assessmentsActions from '../../redux/actions/assessmentsActions';
import * as sectionsActions from '../../redux/actions/sectionsActions';

import SoftAlert from '../common/SoftAlert';
import NewAssessmentAccordions from '../features/assessment/NewAssessmentAccordions';
import SectionSelectorItem from '../features/assessment/SectionSelectorItem';

class NewAssessmentPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSoftAlert: false,
      serverErrors: [],
    };
  }

  componentDidMount() {
    const { status, dispatchSectionsActions } = this.props;
    if (!status.sections) {
      dispatchSectionsActions.getSections();
    }
  }

  selectSectionAndStart = (selectedSection) => {
    const { dispatchAssessmentsActions, dispatchSectionsActions } = this.props;
    dispatchSectionsActions.getSection(selectedSection);
    dispatchAssessmentsActions.selectSection(selectedSection, this.onSelectSectionAndStartFailure);
    // Route is changed in assessmentFlow
  }

  onSelectSectionAndStartFailure = (error) => {
    // Override any previous errors' timeouts
    clearTimeout(this.hideSoftAlertTimeout);
    clearTimeout(this.clearSoftAlertDataTimeout);
    this.setState({
      serverErrors: error.response
        ? error.response.data
        : ['There was a problem connecting to the server.'],
      showSoftAlert: true,
    });
    this.hideSoftAlertTimeout = setTimeout(() => {
      // Begin hiding the alert after 2 seconds
      this.setState({ showSoftAlert: false });
      this.clearSoftAlertDataTimeout = setTimeout(() => {
        // Clear the data after the transition is done
        this.setState({ serverErrors: [] });
      }, 200);
    }, 2000);
  }

  render() {
    const { serverErrors, showSoftAlert } = this.state;
    const { sections } = this.props;

    return (
      <Fragment>
        <Helmet>
          <title>New Assessment</title>
        </Helmet>
        <div className="page-header">
          <div className="row">
            <h1 className="page-header__heading">New Assessment</h1>
          </div>
        </div>
        <NewAssessmentAccordions />
        <div className="section-selector row">
          <div className="section-selector__list">
            {Object.entries(sections).map(([id, section]) => (
              <SectionSelectorItem
                key={id}
                id={id}
                section={section}
                selectSectionAndStart={this.selectSectionAndStart}
              />
            ))}
          </div>
          <div className="section-selector__sidebar">
            <Link to="/download" className="button button--full-width button--large">
              Offline Assessment
            </Link>
            <p>
              Need to take it offline?
              <br />
              Click above to print a module so you can complete it on paper. You can scan your paper module and upload the PDF later.
            </p>
          </div>
        </div>
        <CSSTransition
          classNames="transition"
          timeout={200}
          in={showSoftAlert}
          mountOnEnter
          unmountOnExit
        >
          <SoftAlert errors={serverErrors} />
        </CSSTransition>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    sections: state.sections,
    currentAssessment: state.assessments.currentAssessment,
    status: state.status,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchAssessmentsActions: bindActionCreators(assessmentsActions, dispatch),
    dispatchSectionsActions: bindActionCreators(sectionsActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewAssessmentPage);



// WEBPACK FOOTER //
// ./src/components/pages/NewAssessmentPage.js